// @ts-ignore
/* eslint-disable */
import {
  getComplianceUserInfo,
  postComplianceLogin,
  postComplianceLogout,
  postComplianceRegister,
} from '@/services/auth/complianceAuthApi';
import { mapComplianceToCurrentUser } from '@/services/auth/complianceUser';
import { getToken, setToken } from '@/utils/utils';
import { request } from '@umijs/max';

/** 当前用户：GET /client/compliance/auth/userinfo（与 xPredictorWeb 一致） */
export async function currentUser(options?: { [key: string]: any }) {
  if (!getToken()) {
    throw new Error('Not login');
  }
  const info = await getComplianceUserInfo(options);
  return {
    data: mapComplianceToCurrentUser(info),
  };
}

/** 退出登录：POST /client/compliance/auth/logout，并清除本地 token */
export async function outLogin(options?: { [key: string]: any }) {
  const token = getToken();
  if (token) {
    try {
      await postComplianceLogout(options);
    } catch {
      /* 仍允许前端清理会话 */
    }
  }
  setToken(null);
  return { data: {}, success: true };
}

/**
 * 登录：POST /client/compliance/auth/login
 * 表单字段为 username，与风控项目一致按 email 传参（支持邮箱或账号即 username 作 email）
 */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const email = (body.username || '').trim();
  const password = body.password || '';
  if (!email || !password) {
    return { status: 'error', type: body.type, currentAuthority: 'guest' };
  }
  try {
    const data = await postComplianceLogin({ email, password }, options);
    if (!data?.token) {
      return { status: 'error', type: body.type, currentAuthority: 'guest' };
    }
    setToken(data.token);
    return {
      status: 'ok',
      type: body.type,
      currentAuthority: data.roles?.[0] || 'user',
    };
  } catch {
    return { status: 'error', type: body.type, currentAuthority: 'guest' };
  }
}

/** 注册：POST /client/compliance/auth/register（query：email、password、username） */
export async function register(body: API.RegisterParams, options?: { [key: string]: any }) {
  const username = (body.username || '').trim();
  const email = (body.email || '').trim();
  const password = body.password || '';
  if (!username || !email || !password) {
    return { status: 'error', success: false };
  }
  try {
    await postComplianceRegister({ username, email, password }, options);
    return { status: 'ok', success: true, currentAuthority: 'user' };
  } catch {
    return { status: 'error', success: false };
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 新建规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'PUT',
    ...(options || {}),
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'DELETE',
    ...(options || {}),
  });
}
